import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "../landing/shared";
import { SITE } from "@/config";

const FAQS = [
  {
    q: "What is included?",
    a: `Every kit includes the Medlinkx Premium Toilet Footstool, FREE personalised constipation counselling by Dr. Burhan Shaikh, and a FREE Digital Bowel Health Guide — all for ${SITE.price}.`,
  },
  {
    q: "How does the footstool work?",
    a: "Place it on the floor in front of your toilet and rest your feet on it while seated. Elevating your feet can help create a more natural, squat-like toilet posture.",
  },
  {
    q: "How do I get my free counselling?",
    a: "Booking details are included inside your kit. You can also message us on WhatsApp after your order and we will help you schedule your session with Dr. Burhan Shaikh.",
  },
  {
    q: "Will this cure constipation?",
    a: "No product can guarantee a cure. The footstool is designed to support a more natural toilet posture, while counselling focuses on bowel habits and lifestyle factors.",
  },
];

const Faq = () => (
  <section data-testid="faq-section" className="bg-ivory py-14 sm:py-20">
    <div className="mx-auto max-w-2xl px-4 sm:px-6">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Quick answers</p>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-3 font-serif text-3xl leading-[1.12] tracking-tight text-navy sm:text-4xl" data-testid="faq-headline">
          Questions?
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map(({ q, a }, i) => (
            <AccordionItem key={q} value={`faq-${i}`} className="border-b border-navy/10" data-testid={`faq-item-${i + 1}`}>
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="py-5 text-left font-serif text-lg font-semibold text-navy hover:no-underline sm:text-xl [&[data-state=open]]:text-gold"
              >
                {q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-charcoal/80 sm:text-base">
                {a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
